import { useCallback, useMemo } from 'react';
import { ApolloCache, FetchResult } from '@apollo/client';
import {
  GetStartEndSettingsDocument,
  PutStartEndSettingInput,
  PutStartEndSettingsMutation,
  usePutStartEndSettingsMutation
} from 'graphql/types';

export const usePutStartEndSettings = (): {
  putStartEndSettings: (
    input: PutStartEndSettingInput
  ) => Promise<
    FetchResult<
      PutStartEndSettingsMutation,
      Record<string, any>,
      Record<string, any>
    >
  >;
  loading: boolean;
} => {
  const [
    putStartEndSettingsMutation,
    { loading }
  ] = usePutStartEndSettingsMutation();

  const putStartEndSettings = useCallback(
    async (input: PutStartEndSettingInput) =>
      await putStartEndSettingsMutation({
        variables: {
          input
        },
        update(cache: ApolloCache<PutStartEndSettingsMutation>) {
          cache.writeQuery({
            query: GetStartEndSettingsDocument,
            data: {
              getStartEndSettings: {
                settings: input?.settings
              }
            }
          });
        }
      }),
    [putStartEndSettingsMutation]
  );

  return useMemo(
    () => ({
      putStartEndSettings,
      loading
    }),
    [putStartEndSettings, loading]
  );
};
